import { TimeReportProjectItemPath } from "./TimeReportProjectItemPath";

export const getTimeReportProjectItemPathId = (path: TimeReportProjectItemPath) =>
  `${path.projectGuid}#${path.payCodeGuid}#${path.date.toISOString()}`;
